'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default =

function () {
    "ngInject";
    return function (input, defaultString) {
        var str = $.trim(input || '');
        if (str == '') {
            return defaultString;
        }
        return input;
    };
};

;


//////////////////
// WEBPACK FOOTER
// ./app/base/filters/default.js
// module id = 11
// module chunks = 0